import { workspaceTransactionHistory } from "@/data/workspaceTransactionHistory";
import { BsCheckCircleFill } from "react-icons/bs";

function RailBadge({ rail }) {
  const key = rail?.toUpperCase() || "ACH";
  const map = {
    ACH: "fp-tx-rail--ach",
    WIRE: "fp-tx-rail--wire",
    CRYPTO: "fp-tx-rail--crypto",
  };
  const cls = map[key] || "fp-tx-rail--crypto";
  return (
    <span className={`fp-tx-pill fp-tx-rail ${cls}`} title="Settlement rail">
      {key}
    </span>
  );
}

function DirectionBadge({ direction }) {
  const isIn = direction === "in";
  return (
    <span
      className={`fp-tx-pill fp-tx-dir ${isIn ? "fp-tx-dir--in" : "fp-tx-dir--out"}`}
      title={isIn ? "Funds in" : "Funds out"}>
      {isIn ? "IN" : "OUT"}
    </span>
  );
}

function FlowPayTransactionsTable({ rows = workspaceTransactionHistory }) {
  return (
    <div className="fp-tx-history">
      <div className="fp-tx-history__scroll">
        <table className="fp-tx-table">
          <thead>
            <tr>
              <th scope="col">In / Out</th>
              <th scope="col">Type</th>
              <th scope="col">From (bank / source)</th>
              <th scope="col">To (crypto / bank)</th>
              <th scope="col">USD</th>
              <th scope="col">Crypto out</th>
              <th scope="col">Status</th>
              <th scope="col">Date</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr
                key={row.id}
                className="fp-tx-table__row"
                data-bs-toggle="modal"
                data-bs-target="#transactionsMod">
                <td>
                  <DirectionBadge direction={row.direction} />
                </td>
                <td>
                  <RailBadge rail={row.rail} />
                </td>
                <td>
                  <span className="fp-tx-table__primary">{row.from}</span>
                </td>
                <td>
                  <span className="fp-tx-table__mono">{row.to}</span>
                </td>
                <td>
                  <span className="fp-tx-table__primary fp-tx-table__usd">
                    {row.usd}
                  </span>
                </td>
                <td>
                  <span
                    className={`fp-tx-table__crypto ${row.crypto && row.crypto !== "—" ? "fp-tx-table__crypto--on" : "fp-tx-table__crypto--muted"}`}>
                    {row.crypto || "—"}
                    {row.cryptoSettled && row.crypto && row.crypto !== "—" ? (
                      <BsCheckCircleFill
                        className="fp-tx-table__check"
                        aria-hidden
                      />
                    ) : null}
                  </span>
                </td>
                <td>
                  <span className={`fp-tx-status fp-tx-status--${row.statusVariant}`}>
                    {row.status}
                  </span>
                </td>
                <td>
                  <span className="fp-tx-table__date">{row.date}</span>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="fp-tx-history__foot">
        All crypto is dispatched on-chain within seconds of USD receipt. FlowPay
        retains no crypto balance.
      </p>
    </div>
  );
}

export default FlowPayTransactionsTable;
